import { Body, Controller, Post } from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import {  VehicleCategoryService } from "./vehicle-category.service";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { CommonResponseModel, VehcileCategoryDto } from "@project-management-system/shared-models";
import { VehicleCategoryDto } from "./vehicle-category.dto";


@Controller('vehicle_category')
@ApiTags('/vehicle_category')
export class VehicleCategoryController {
    constructor(private service: VehicleCategoryService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) { }

    @Post('/getAllVehicleCategory')
    async getAllVehicleCategory(): Promise<CommonResponseModel> {
        try {
            return await this.service.getAllVehicleCategory();
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/createVehicleCategory')
    @ApiBody({ type: VehicleCategoryDto })
    async createVehicleCategory(@Body() req?: any): Promise<CommonResponseModel> {
        try {
            // console.log(req, 'ppppppppppp');

            return await this.service.createVehicleCategory(req,false);
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }

    }

    @Post('/getActiveAllVehicleCategory')
    async getActiveAllVehicleCategory(): Promise<CommonResponseModel> {
        try {
            return await this.service.getActiveAllVehcileCategory();
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/updateVehicleCatgeory')
    @ApiBody({ type: VehicleCategoryDto })
    async updateVehicleCatgeory(@Body() req: any): Promise<CommonResponseModel> {
        try {


            return await this.service.createVehicleCategory(req,true);
        } catch (error) {
            // return errorHandler(ProcurmentGroupResponseModel,error);
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/activateOrDeactivateVehicleCategory')
    @ApiBody({ type: VehicleCategoryDto })
    async activateOrDeactivateVehicleCategory(@Body() dto: any): Promise<CommonResponseModel> {
        try {
            return await this.service.activateOrDeactivateVehicleCategory(dto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

}